<script context="module">
    export function getColor(color){
		if(color==1){
			return "red";
		}
		else if(color==2){
			return "green";
		}
		else if(color==3){
			return 'darkorange';
		}
		else if(color==4){
			return 'brown';
		}
		else if(color==5){
			return 'purple';
		}
	}
</script>